import React from "react";
import CustomButton from "@/components/ratl/utility/CustonButton";
import { RT_INTRO_VIDEO_YT, RT_STUDIO_RIL } from "@/data";
import { useFloat } from "@/lib";
import { Play, PlayCircle } from "lucide-react";

const NavbarCTA: React.FC = () => {
  const { float, handleFloat } = useFloat([false, false]);
  return (
    <div className="flex items-center gap-2">
      <CustomButton
        text={"Run a Test Now"}
        animationRequired={false}
        bgType={"solid"}
        onClick={() => {
          window.open(RT_STUDIO_RIL, "_blank");
        }}
        onMouseEnter={() => handleFloat(true, 1)}
        onMouseLeave={() => handleFloat(false, 1)}
        controller={float[1]}
        btnSize="small"
        isStudioBtn={false}
        className="px-4 py-2 text-sm transition w-fit rounded-lg border-solid border-[1px] hover:bg-transparent hover:text-black hover:border-solid hover:border-black hover:border-[1px]"
      />
    </div>
  );
};

export default NavbarCTA;
